import React from "react";
import {
  RACI_ROLES,
  ROLE_LABELS,
  PARTICIPANT_CURRENCY,
  VALUE_CLASS_META,
} from "../../utils/whatif/whatIfNormalize";
import {
  formatAmount,
  formatDurationShort,
  formatPercent,
  formatRate,
} from "../../utils/whatif/whatIfFormat";

const Participant = ({ participant, timeUnit, currency, rates }) => (
  <li className="wif-raci-participant">
    <div className="wif-raci-participant-name">
      {participant.jobName}
      {participant.source !== "original" && (
        <span className="wif-raci-tag">{participant.source}</span>
      )}
    </div>
    <div className="wif-raci-participant-meta">
      {formatDurationShort(participant.minutes, timeUnit)}
      {participant.allocationPercent != null &&
        ` · ${formatPercent(participant.allocationPercent)} allocated`}
    </div>
    <div className="wif-raci-participant-cost">
      {formatAmount(participant.costUsd, PARTICIPANT_CURRENCY, currency, rates)}
      <span className="wif-raci-participant-rate">
        {formatRate(
          participant.hourlyRateUsd,
          PARTICIPANT_CURRENCY,
          currency,
          rates,
          timeUnit,
        )}
      </span>
    </div>
  </li>
);

const RoleCell = ({ role, participants, timeUnit, currency, rates }) => (
  <div className={`cell wif-raci-cell wif-raci-cell--${role}`}>
    {/* Repeated per cell so the stacked layout below 900px, where the table
        header is hidden, still identifies which role each group belongs to. */}
    <div className="wif-raci-cell-label" aria-hidden="true">
      {ROLE_LABELS[role]} ({role})
    </div>

    {participants.length ? (
      <ul className="wif-raci-participant-list">
        {participants.map((participant) => (
          <Participant
            key={`${participant.role}-${participant.jobId}`}
            participant={participant}
            timeUnit={timeUnit}
            currency={currency}
            rates={rates}
          />
        ))}
      </ul>
    ) : (
      <span className="wif-raci-cell-empty">—</span>
    )}
  </div>
);

const RaciTaskRow = ({ task, gridTemplateColumns, timeUnit, currency, rates }) => (
  <div
    className={`roles-table-row wif-raci-row${task.eliminated ? " wif-raci-row--eliminated" : ""}`}
    style={{ gridTemplateColumns }}
  >
    <div className="cell wif-raci-task-cell">
      <div className="wif-raci-task-heading">
        <span className="wif-raci-task-name">{task.taskName}</span>
        {/* The figures below stay at full value — they are what dropping this
            task saved, not what it still contributes to the totals. */}
        {task.eliminated && (
          <span
            className="wif-eliminated-badge"
            title={`${VALUE_CLASS_META.NVA.full} — ${VALUE_CLASS_META.NVA.hint}`}
          >
            NVA
          </span>
        )}
      </div>
      <dl className="wif-raci-task-facts">
        <div>
          <dt>Cost</dt>
          <dd>
            {formatAmount(
              task.totalCostUsd,
              PARTICIPANT_CURRENCY,
              currency,
              rates,
            )}
          </dd>
        </div>
        <div>
          <dt>Effort</dt>
          <dd>{formatDurationShort(task.minutesTotal, timeUnit)}</dd>
        </div>
        <div>
          <dt>People</dt>
          <dd>{task.participantCount}</dd>
        </div>
      </dl>
    </div>

    {RACI_ROLES.map((role) => (
      <RoleCell
        key={role}
        role={role}
        participants={task.participantsByRole[role]}
        timeUnit={timeUnit}
        currency={currency}
        rates={rates}
      />
    ))}
  </div>
);

export default RaciTaskRow;
